import { ADDONS_PAGE_URL } from "@constants";
import { Grid, GridProps, Link, Stack, Typography } from "@mui/material";
import { ISubscription } from "@pages/AccountDetails/interface/IAccountDetailsPage";
import { useTranslation } from "react-i18next";
import { useHistory } from "react-router-dom";
import { useStyle } from "./style";

interface IParams {
    addons: NonNullable<ISubscription["addons"]>;
    isMobileDomain: boolean;
}

export const AddonsOfferDetails = (props: IParams) => {
    const { addons, isMobileDomain } = props;
    const { push } = useHistory();
    const { classes } = useStyle();
    const { t } = useTranslation(["accountDetails", "common"]);
    const align: GridProps["textAlign"] = { xs: "center", sm: isMobileDomain ? "left" : "center" };

    return (
        <Stack spacing={1} width="auto">
            <Typography
                color="primary"
                gutterBottom
                paddingTop={0.5}
                textAlign={isMobileDomain ? { xs: "center", md: "left" } : "center"}
                variant="h4"
            >
                {t("accountDetails:activeAddOns")}
            </Typography>
            {addons.map(({ description, price, quantity }) => (
                <Grid container key={`${description}`} spacing={1}>
                    <Grid item md={isMobileDomain ? 6 : 4} textAlign={align} xs={6}>
                        <Typography color="secondary" fontWeight="bold" variant="normal">
                            {t("accountDetails:addonDescription", { description, quantity })}
                        </Typography>
                    </Grid>
                    <Grid item md={isMobileDomain ? 3 : 4} textAlign="center" xs={6}>
                        <Typography color="secondary" variant="large">
                            {t("common:price", { price })}
                        </Typography>
                    </Grid>
                    <Grid item md={isMobileDomain ? 3 : 4} textAlign="center" xs={12}>
                        <Link className={classes.link} underline="always" onClick={() => push(`${ADDONS_PAGE_URL}`)}>
                            <Typography color="primary" variant="normal">
                                {t("accountDetails:manageAddOns")}
                            </Typography>
                        </Link>
                    </Grid>
                </Grid>
            ))}
        </Stack>
    );
};
